export default (value) => (dispatch) => {
  dispatch({
    type: 'TBT_SIGNING_SET_SEARCH_TERM',
    payload: value,
  })
}
